import {useEffect, useState, useMemo, useCallback, useRef} from 'react';
import { CompareArrows as TransferIcon } from '@material-ui/icons';
import { Button, Grid, makeStyles } from '@material-ui/core';
import _, { isEmpty } from 'lodash';
import { OnChange } from 'react-final-form-listeners';
import { Trans, useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import QCXInfoAlert from '../../shared-components/alert/QCXInfoAlert';
import QCXDynamicFieldGroup from '../../shared-components/dynamic-field-group/QCXDynamicFieldGroup';
import QCXFinalCheckboxField from '../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectCodigoReceitaAutocomplete from '../../shared-components/final-select-codigo-receita-field/QCXSelectCodigoReceitaAutocomplete';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import { PAGAMENTODI } from '../../ts/common/hooks/useHasPermission/permissionsEnum';
import { useHasPermission } from '../../ts/common/hooks/useHasPermission/useHasPermission';
import { normalizeNumeral, unnormalizeNumeral } from '../../utils/general/general-utils';
import { isNaoCalculadaStatus } from '../../utils/general/operations/operationUtils';
import { formatBrazilianNumericDecimal } from '../../utils/hooks/form/field/formatters';
import QCXFormSubtitle from '../form-title/QCXFormSubtitle';
import QCXFormTitle from '../form-title/QCXFormTitle';
import QCXDeclaracaoImportacaoBondManagerPagamentosRetificacao from './QCXDeclaracaoImportacaoBondManagerPagamentosRetificacao';
import QCXButton from '../../shared-components/button/QCXButton';

const useStyles = makeStyles(() => ({
  gridFields: {
    paddingBottom: '16px',
  },
  fakeFields: {
    height: '40px !important',
    paddingBottom: '16px',
  },
}));

export default function QCXDeclaracaoImportacaoPagamentosRetificadoForm({
  initialValues,
  handleSubmit,
  isConsult,
  controlComponentProps,
  values,
  ...restProps
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [pagamentos, setPagamentos] = useState([]);
  const hasPermissionToEditBanco = useHasPermission(PAGAMENTODI.ALTERAR);

  const form = useForm();
  const { valuesForm } = form.getState();

  const somarPagamentos = (currentValues) => {
    let total = 0;

    const pagamentosRetificacao = currentValues?.atributosAdicionais?.pagamentos?.filter(el => el.isRetificacao);
    pagamentosRetificacao.forEach((pagamento) => {
      total += normalizeNumeral(pagamento.valorReal);
    });

    return unnormalizeNumeral(total, formatBrazilianNumericDecimal(2));
  };

  useEffect(() => {
    const pagamentosValues = values?.atributosAdicionais?.pagamentos;

    setPagamentos(pagamentosValues);

  }, [values])


  useEffect(() => {
    console.log(values);
  }, [values])

  const bondRef = useRef(null);

  const scrollToBondManager = () => {
    bondRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const transferDataToBondManager = ({id, idRetificacao, identificacao, valorOriginal, valorRetificacao, valorDiferenca}) => {
    const idPagamento = idRetificacao || id;
    const rootName = 'ignorableFields.tributacao';
    
    const pagamentosArray = _.get(values, 'atributosAdicionais.pagamentos');
    
    if (!pagamentosArray) {
      console.log('Pagamento não encontrado');
      return ;
    }

    const pagamentoSelecionado = pagamentosArray.find(el => el.id === idPagamento);

    if (pagamentoSelecionado) {
      form.change(rootName, pagamentoSelecionado);
    } else {
      return ;
    }

    scrollToBondManager();

  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <QCXFormTitle title={t('com.muralis.qcx.pagamento.fichaPagamentos')} />
        </Grid>

        {isEmpty(values?.atributosAdicionais?.pagamentos) && isNaoCalculadaStatus(values?.calculada) && (
          <Grid item xs={12}>
            <QCXInfoAlert>
              <Trans i18nKey="com.muralis.qcx.mensagem.dadosRelacionadosGeradosDICalculada">
                <em>
                  <strong>
                    {{
                      tributo: t('com.muralis.qcx.impostoTaxa').toLowerCase(),
                    }}
                  </strong>
                  <strong>
                    {{
                      dadosrelacionados: t('com.muralis.qcx.outrosDadosRelacionados').toLowerCase(),
                    }}
                  </strong>
                  <strong>
                    {{
                      DI: t('com.muralis.qcx.declaracaoImportacao'),
                    }}
                  </strong>
                  <strong>
                    {{
                      estado: t('com.muralis.qcx.estado.calculada').toLowerCase(),
                    }}
                  </strong>
                </em>
              </Trans>
            </QCXInfoAlert>
          </Grid>
        )}

        <QCXDynamicFieldGroup
          rootName="ignorableFields.pagamentos"
          list={values?.ignorableFields?.pagamentos}
          keysProps={{
            id: null,
            identificacao: null,
            idRetificacao: null,
            valorOriginal: null,
            valorRetificacao: null,
            valorDiferenca: null,
          }}
        >
          {({identificacao, valorOriginal, valorRetificacao, valorDiferenca, props, index }) => (
            <>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <QCXFinalTextField
                  id="text-identificacao-field"
                  key="text-identificacao-field"
                  name={identificacao?.name}
                  label={index === 0 ? t('com.muralis.qcx.impostosOuTaxas') : undefined}
                  disabled
                />
              </Grid>
              
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <QCXFinalAlternativeCurrencyField
                  id="currency-valor-field"
                  key="currency-valor-field"
                  name={valorOriginal?.name}
                  label={index === 0 ? `${t('com.muralis.qcx.valor')} Original` : undefined}
                  scale={2}
                  adorned
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <QCXFinalAlternativeCurrencyField
                  id="currency-valor-field"
                  key="currency-valor-field"
                  name={valorRetificacao?.name}
                  label={index === 0 ? `${t('com.muralis.qcx.valor')} Retificado` : undefined}
                  scale={2}
                  adorned
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <QCXFinalAlternativeCurrencyField
                  id="currency-valor-field"
                  key="currency-valor-field"
                  name={valorDiferenca?.name}
                  label={index === 0 ? `Diferença` : undefined}
                  scale={2}
                  adorned
                  disabled
                  InputProps={{
                    style: {
                      backgroundColor: '#fff3e0',
                      border: '2px solid #ff9800',
                      borderRadius: '4px',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <Button
                  onClick={() => transferDataToBondManager({...props})}
                >
                  <TransferIcon />
                </Button>
              </Grid>

            </>
          )}
        </QCXDynamicFieldGroup>

        <Grid item container xs={12} style={{ paddingTop: '1vh' }}>
          <Grid item xs={6}>
            <QCXFormSubtitle title={`Valor total dos Impostos de Retificação: R$ ${somarPagamentos(values)}`} />
          </Grid>
        </Grid>

        <div ref={bondRef}>
          <QCXDeclaracaoImportacaoBondManagerPagamentosRetificacao 
            isConsult={isConsult}
          />
        </div>

      </Grid>
    </>
  );
}
